import * as React from 'react';

export const ClickIcon: React.FC = () => {
  return (
    // eslint-disable-next-line react/forbid-elements
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_287_25341)">
        <path d="M9.5 9.5L14 14" stroke="var(--accent-main-primary)" strokeWidth="2" />
        <path
          d="M3.05146 1.63604L1.63725 3.05025L3.75857 5.17157L5.17278 3.75736L3.05146 1.63604Z"
          fill="var(--accent-main-primary)"
        />
        <path
          d="M1.63725 12.9497L3.75857 10.8284L5.17278 12.2426L3.05146 14.364L1.63725 12.9497Z"
          fill="var(--accent-main-primary)"
        />
        <path
          d="M10.8296 3.75736L12.951 1.63604L14.3652 3.05025L12.2438 5.17157L10.8296 3.75736Z"
          fill="var(--accent-main-primary)"
        />
        <path d="M3.00118 7.00004H0.00117722V9.00004H3.00118V7.00004Z" fill="var(--accent-main-primary)" />
        <path
          d="M7.00118 4.34322e-05L9.00118 4.37694e-05L9.00118 3.00004L7.00118 3.00004L7.00118 4.34322e-05Z"
          fill="var(--accent-main-primary)"
        />
        <path
          d="M5.83038 5.8288L8.65881 14.3141L10.502 10.5004L14.3157 8.65722L5.83038 5.8288Z"
          fill="var(--accent-main-primary)"
        />
      </g>
      <defs>
        <clipPath id="clip0_287_25341">
          <rect width="16" height="16" fill="var(--theme-white)" transform="matrix(-1 0 0 1 16 0)" />
        </clipPath>
      </defs>
    </svg>
  );
};
